<template>
  <div class="content-container" v-if="vehicleData">
    <!-- Panel boczny z informacjami o pojeździe -->
    <div class="side-info">
      <!-- Data i godzina rejestracji pojazdu -->
      <div class="date-time">
        <span>{{ t('registration-at-preselection-station') }}</span>
        <div class="d-flex">
          <div class="fw-bold date">
            {{ moment(vehicleData.createdAt).format("DD.MM.YYYY") }}
          </div>
          <div class="fw-bold time">
            {{ moment(vehicleData.createdAt).format("HH:mm:ss") }}
          </div>
        </div>
      </div>
      <!-- Lokalizacja pojazdu -->
      <div class="location">
        <span>{{ t('preselection-station') }}</span>
        <div class="fw-bold">
          {{ vehicleData.location.shortName }}
        </div>
      </div>
      <!-- Numer rejestracyjny i flaga kraju -->
      <div class="row plate-item">
        <div class="col-3 plate-flag center-aligned"
        :style="{ backgroundColor: getCode(vehicle.nationality) ? '' : 'white'}">
          <div class="row">
            <div>
              <country-flag
                :country="getCode(vehicleData.nationality)"
                size="small"
              />
            </div>
          </div>
          <div class="row">
            <div>{{ getCode(vehicle.nationality) ? getCode(vehicle.nationality) : "" }}</div>
          </div>
        </div>
        <div class="col-9 plate">{{ vehicleData.plateLpr }}</div>
      </div>
      <!-- Pozostałe informacje (pas, kategorie, numer pojazdu) -->
      <div class="info d-flex">
        <div class="label">{{ t('lane-number') }}:</div>
        <div class="fw-bold value">
          {{ vehicleData.lane.laneNumber }}
        </div>
      </div>
      <div v-if="!isSG" class="info d-flex">
        <div class="label">{{ t('category') }} [8+1]:</div>
        <div class="fw-bold value">{{ vehicleData.ctg8p1 }}</div>
      </div>
      <div v-if="!isSG" class="info d-flex">
        <div class="label">{{ t('category') }} [COST 323]:</div>
        <div class="fw-bold value">{{ vehicleData.ctg323 }}</div>
      </div>
      <div class="info d-flex">
        <div class="label">{{ t('another-vehicle-number') }}:</div>
        <div class="fw-bold value">{{ vehicleData.id }}</div>
      </div>

      <div class="info d-flex" v-if="euroNorms && euroNorms.make">
        <div class="label">Marka:</div>
        <div class="fw-bold value">{{ euroNorms.make ?? '' }}</div>
      </div>
      <div class="info d-flex" v-if="euroNorms && euroNorms.model">
        <div class="label">Model:</div>
        <div class="fw-bold value">{{ euroNorms.model ?? '' }}</div>
      </div>
      <div class="info d-flex" v-if="euroNorms && euroNorms.veh_type && euroNorms.veh_type !== '---'">
        <div class="label">Nr katalogowy:</div>
        <div class="fw-bold value">{{ euroNorms.veh_type ?? '' }}</div>
      </div>
      <div class="info d-flex" v-if="euroNorms && euroNorms.euro_norm">
        <div class="label">Norma EURO:</div>
        <div class="fw-bold value">{{ euroNorms.euro_norm ?? '' }}</div>
      </div>
      <div class="info d-flex" v-if="euroNorms && euroNorms.production_date">
        <div class="label">Data produkcji:</div>
        <div class="fw-bold value">{{ euroNorms.production_date ?? '' }}</div>
      </div>
      <div class="info d-flex" v-if="euroNorms && euroNorms.fuel_type">
        <div class="label">Rodzaj paliwa:</div>
        <div class="fw-bold value">{{ euroNorms.fuel_type ?? '' }}</div>
      </div>
    </div>
    <!-- Szczegóły pojazdu i interaktywne akcje -->
    <div class="details">
      <div class="d-flex justify-content-between actions">
        <!-- Przycisk powrotu (do listy) -->
        <!-- <button class="btn-prev" :class="moment(vehicleData.checkpointTime).isAfter(moment()) ? '' : 'no-timer'" @click="back()">
          <span>{{ t('back').toUpperCase() }}</span>
        </button> -->
        <!-- Timer - czas do przyjazdu -->
        <!-- <div class="timer" v-if="moment(vehicleData.checkpointTime).isAfter(moment())">
          {{ t('arrival') }}:
          <CountdownTimer
            :deadline="
              moment(vehicleData.checkpointTime).format('YYYY/MM/DD HH:mm:ss')
            "
          />
        </div> -->
        <!-- przycisk "Back" – klasa zależna od checkpoint + momentDiffServer -->
        <button
          class="btn-prev"
          :class="moment(vehicleData.checkpointTime).add(momentDiffServer, 'ms').isAfter(moment()) ? '' : 'no-timer'"
          @click="back()"
        >
          <span>{{ t('back').toUpperCase() }}</span>
        </button>

        <!-- Timer – widoczny dopóki checkpoint + momentDiffServer > teraz -->
        <div class="timer"
            v-if="moment(vehicleData.checkpointTime).add(momentDiffServer, 'ms').isAfter(moment())">
          {{ t('arrival') }}:
          <CountdownTimer
            :deadline="moment(vehicleData.checkpointTime).format('YYYY/MM/DD HH:mm:ss')"
            :server-diff="momentDiffServer"
          />
        </div>
        <!-- Akcje dla scenariuszy VMS i pobierania PDF -->
        <div class="buttons">
          <!-- Akcje związane z VMS (wyświetlanie tablicy, itp.) -->
          <div v-if="vehicleData.plateVmsReadablePointAt" class="dropdown-wrapper" ref="dropdown">
            <button class="btn" :disabled="!canManageVms" @click="handleVmsButton()">
              <span style="padding: 10px;">{{ buttonText }}</span>
            </button>
            <ul v-show="isOpen" class="dropdown-list">
              <li @click="displayAllTrucks">Wszystkie ciężarówki</li>
              <li @click="displayPlateNumber">Numer rejestracyjny</li>
            </ul>
          </div>
          <!-- Pobieranie raportu PDF -->
          <button class="btn" @click="retrieveZip">
            <span>PDF</span>
          </button>
        </div>
      </div>
      <!-- Zdjęcia pojazdu (przełączanie kliknięciem) -->
      <div class="row" id="images" v-if="vehicleData.images.length > 0">
        <div @click="nextImage" style="cursor: pointer;">
          <vehicle-image
            :vehicle="vehicleData"
            :image-service="vehService"
            :set-image-with-number="currentImageIndex + 1"
            :image="vehicleData.images[currentImageIndex]"
            v-on:wasSet="wasSetCallback"
          />
        </div>
      </div>
      <!-- Parametry pojazdu (masy, długość, prędkość, itp.) -->
      <div class="vehicle-params" v-if="!shouldHideLocation">
        <h3>
          {{ t('vehicle-parameters') }}
        </h3>
        <div class="d-flex vehicle-data" id="vehicle-data">
          <!-- Lewa kolumna: masy i przeciążenia -->
          <div class="col-4">
            <div class="row" :class="{ violation: vehicleData.overloadSA }">
              <div class="col-9">{{ t('vehicle-axle') }} [%]</div>
              <div class="col-3">{{ evaluateInt(vehicleData.overloadSA) }}</div>
            </div>
            <div class="row" :class="{ violation: vehicleData.overloadMA }">
              <div class="col-9">{{ t('multiple-axises') }} [%]</div>
              <div class="col-3">{{ evaluateInt(vehicleData.overloadMA) }}</div>
            </div>
            <div class="row" :class="{ violation: vehicleData.overloadTL }">
              <div class="col-9">{{ t('dmc') }} [%]</div>
              <div class="col-3">{{ evaluateInt(vehicleData.overloadTL) }}</div>
            </div>
          </div>
          <!-- Środek: typy, długość, wysokość, prędkość, liczba osi -->
          <div class="col-4">
            <div class="row">
              <div class="col-9">{{ t('vehicle-type') }}</div>
              <div class="col-3">
                {{ vehicleData.ctg8p1 }} / {{ vehicleData.ctg323 }}
              </div>
            </div>
            <div class="row">
              <div class="col-9">{{ t('length') }} [cm]</div>
              <div class="col-3">{{ evaluateInt(vehicleData.vehLength) }}</div>
            </div>
            <div class="row" :class="{ violation: vehicleData.overheight }">
              <div class="col-9">{{ t('height') }} [cm]</div>
              <div class="col-3">
                {{ evaluateDecimal(vehicleData.vehHeight) }}
              </div>
            </div>
            <div class="row" :class="{ violation: vehicleData.overspeed }">
              <div class="col-9">{{ t('speed') }} [km/h]</div>
              <div :class="'col-3 measurement-row-field-b'">
                {{ evaluateInt(vehicleData.speed) }}
              </div>
            </div>
            <div class="row">
              <div class="col-9">{{ t('axles-no') }}</div>
              <div class="col-3">
                {{ evaluateInt(vehicleData.numberOfAxles) }}
              </div>
            </div>
          </div>
          <!-- Prawa kolumna: naruszenia i wyjazdy poza pas -->
          <div class="border-right-0 col-4">
            <div class="row" :class="{ violation: vehicleData.wrongDirection }">
              <div class="col-9">{{ t('wrong-direction') }}</div>
              <div class="col-3">
                {{ evaluateBoolean(vehicleData.wrongDirection) }}
              </div>
            </div>
            <div class="row" :class="{ violation: vehicleData.overlane }">
              <div class="col-9">{{ t('outside-the-lane') }}</div>
              <div class="col-3">
                {{ evaluateBoolean(vehicleData.overlane) }}
              </div>
            </div>
            <div class="row" :class="{ violation: vehicleData.overheight }">
              <div class="col-9">{{ t('height') }}</div>
              <div class="col-3">
                {{ evaluateBoolean(vehicleData.overheight) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Masa całkowita z klasą dokładności -->
      <div class="axis-info" v-if="!shouldHideLocation">
        <h3>{{ t('total-weight-with-accuracy-class') }}: {{ vehicleData.lane.accuracyClass.name }}</h3>
        <div class="row center-aligned">
          <div class="axis-info-data-mass">
            <!-- Tabela z minimalną, aktualną i maksymalną masą całkowitą -->
            <div class="row" id="axisTopRow">
              <div class="col">-</div>
              <div class="col">
                {{ vehicleData.axlesComplex.minTotalLoad }}
              </div>
            </div>
            <div class="row" id="axisNameRow">
              <div class="col middle-axis-value">kg</div>
              <div class="col middle-axis-value" :class="{ overload: vehicleData.overload }">
                {{ vehicleData.axlesComplex.totalLoad }}
              </div>
            </div>
            <div class="row" id="axisBottomRow">
              <div class="col">+</div>
              <div class="col">
                {{ vehicleData.axlesComplex.maxTotalLoad }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Rozstaw osi i masy osi -->
      <div class="axis-info" v-if="!shouldHideLocation">
        <h3>{{ t('axle-spacing-and-load-with-accuracy-class') }}: {{ vehicleData.lane.accuracyClass.name }}</h3>
        <table class="axis-table">
          <thead>
            <!-- Nagłówki dla rozstawów osi (góra, środek, dół) -->
            <tr class="row-top">
              <th>-</th>
              <th
                v-for="(group, i) in mergedAxlesData"
                :key="'minus-' + i"
                :colspan="group.colspan"
                :class="{ 'wheel-diff-gap': group.isGap }"
              >
                <template v-if="!group.isGap">
                  <span :class="{ 'overload': group.overload == true }">
                    {{ group.dataAxMinus }}
                  </span>
                </template>
              </th>
            </tr>

            <tr class="row-center">
              <td>{{ t('axle').toUpperCase() }}</td>
              <template v-for="(group, i) in mergedAxlesData" :key="'center-' + i">
                <td
                  :colspan="group.colspan"
                  :class="{ 'wheel-diff-gap': group.isGap }"
                >
                  <span v-if="!group.isGap" :class="{ 'overload': group.overload == true }">
                    {{ group.dataAxCenter }}
                  </span>
                </td>
              </template>
            </tr>
            <tr class="row-bottom">
              <th>+</th>
              <th v-for="(ax, i) in mergedAxlesData" :key="'plus-' + i" :colspan="ax.colspan">
                <span :class="{ 'overload': ax.overload == true }">
                  {{ ax.dataAxCenter }}
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="row-wheels-top">
              <th>{{ t('wheel').toUpperCase() }} [kg]<br />{{ t('right').toUpperCase() }}</th>
              <template v-for="(ax, i) in axlesData" :key="'top-' + i">
                <td>{{ ax.dataRight }}</td>
                <td v-if="ax.gapAfter > 0" class="wheel-diff-gap"></td>
              </template>
            </tr>

            <tr class="row-wheels-icons">
              <th>[cm]</th>
              <template v-for="(ax, i) in axlesData" :key="'diff-' + i">
                <td>
                  <div class="wheel-icon" :class="{ overload: ax.overload }">
                    <img
                      :src="require(`@/assets/icons/${ax.overload ? 'kola_02' : 'kola_01'}.png`)"
                      alt=""
                    />
                  </div>
                </td>
                <td v-if="ax.gapAfter > 0" class="wheel-diff-gap">
                  {{ ax.gapAfter }}
                </td>
              </template>
            </tr>

            <tr class="row-wheels-bottom">
              <th>{{ t('left').toUpperCase() }}</th>
              <template v-for="(ax, i) in axlesData" :key="'bottom-' + i">
                <td>{{ ax.dataLeft }}</td>
                <td v-if="ax.gapAfter > 0" class="wheel-diff-gap"></td>
              </template>
            </tr>
          </tbody>
        </table>
<!--        <div class="d-flex justify-content-between actions-down">-->
<!--          <button class="btn-prev" @click="back()">-->
<!--            <span>{{ t('back').toUpperCase() }}</span>-->
<!--          </button>-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import CurrentMeasurementsService from "@/services/CurrentMeasurementsService";
import ArchivalMeasurementsService from "@/services/ArchivalMeasurementsService";
import CountryFlag from "vue-country-flag-next";
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from "chart.js";
import VehicleImage from "@/components/VehicleImage";
import CountdownTimer from "@/components/current/countdown-timer";
import { useArchivalFiltersStore } from "@/stores/archivalFilters";
// import { useCurrentFiltersStore } from "@/stores/currentFilters";
import { useUserStore } from "@/stores/user.store";
import {useCurrentStore} from "@/stores/current";
import { isSG } from "@/config/appVersion";

require("../assets/css/viver-style.css");

moment.locale("pl");
const getCountryISO2 = require("country-iso-3-to-2");

// Rejestracja komponentów Chart.js potrzebnych do wykresów (jeśli występują)
ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

export default {
  name: "VehicleDetails",
  // Po zamontowaniu komponentu - ustaw krok jeśli jest w URL, nasłuchuj na kliknięcie poza dropdownem
  async mounted() {
    const step = this.$route.query.step;
    if (step) {
      this.previousStep = parseInt(step);
    }

    document.addEventListener('click', this.onClickOutside);

    if (this.userStore && typeof this.userStore.self === 'function') {
      await this.userStore.self();
    }
    const prefs  = (this.userStore && this.userStore.preferences) || {};
    const addSec = Number(prefs.checkpointAdditionalTime || 0);
    this.momentDiffServer = addSec * 1000; // ms
  },
  // Usuń nasłuchiwanie na kliknięcie po zdemontowaniu komponentu
  beforeUnmount() {
    document.removeEventListener('click', this.onClickOutside);
  },
  components: {
    CountryFlag,
    VehicleImage,
    CountdownTimer,
  },
  props: {
    timerVisible: {
      default: true,
    },
  },

  data() {
    return {
      moment: moment,
      // Obiekt z danymi pojazdu
      vehicle: this.vehicle,
      // Dane o osiach pojazdu
      axlesData: this.axlesData,
      // Dane do wykresów
      chartData: this.chartData,
      chartOptions: {
        responsive: true,
      },
      selectedSmallImage: 0,
      isDownloading: false,
      currentImageIndex: 0,
      previousStep: null,
      previousQuery: {},
      isOpen: false, // Czy rozwinięta jest lista opcji VMS
      canManageVms: false, // Czy użytkownik może zarządzać znakiem VMS
      buttonText: 'Scenariusz dla znaku nie jest włączony',
      momentDiffServer: 0, // Korekta czasu względem serwera
      userStore: useUserStore(),
      euroNorms: null,
      isSG,
    };
  },
  computed: {
    // Wyciąganie wartości z .env./// żeby nie wyświetlać różnych elementów strony dla różnych klientów
    shouldHideLocation() {
      // Odczytujemy wartość z process.env
      const version = process.env.VUE_APP_VERSION_NAME || "";
      // Jeśli zaczyna się od "SG", zwracamy true -> ukryjemy div
      return version.startsWith("SG");
    },
    // Zwraca dane pojazdu do szablonu
    vehicleData() {
      return this.vehicle;
    },
    // Wybiera odpowiedni serwis w zależności od widoku (aktualny/archiwalny)
    vehService() {
      if (this.$route.path.startsWith("/vehicleArch")) {
        return ArchivalMeasurementsService;
      }
      return CurrentMeasurementsService;
    },
    // Czy można pobrać raport PDF (tylko w archiwalnych)
    zipAvailable() {
      if (this.$route.path.startsWith("/vehicleArch")) {
        return true;
      }
      return false;
    },
    selectedSmall() {
      return this.selectedSmallImage;
    },
    // Łączy dane osi do prezentacji w tabeli (grupowanie osi z małymi odstępami)
    mergedAxlesData() {
      const merged = [];
      const data = this.axlesData;
      let i = 0;

      while (i < data.length) {
        const group = [data[i]];
        let j = i;

        // Grupuje kolejne osie z niewielkimi przerwami
        while (
          j + 1 < data.length &&
          data[j].gapAfter > 0 &&
          data[j].gapAfter <= 180
        ) {
          j++;
          group.push(data[j]);
        }

        const groupLength = group.length;
        const colspan = 2 * groupLength - 1;

        // Tworzy obiekt grupy osi
        const mergedGroup = {
          colspan,
          groupSize: groupLength,
          overload: group.some(ax => ax.overload),
          axes: group,
          dataAxMinus: group.reduce((sum, g) => sum + (g.dataAxMinus || 0), 0),
          dataAxCenter: group.reduce((sum, g) => sum + (g.dataAxCenter || 0), 0),
          dataAxPlus: group.reduce((sum, g) => sum + (g.dataAxPlus || 0), 0),
          dataLeft: group.reduce((sum, g) => sum + (g.dataLeft || 0), 0),
          dataRight: group.reduce((sum, g) => sum + (g.dataRight || 0), 0),
        };

        merged.push(mergedGroup);

        // Dodaje specjalny obiekt jeśli odstęp między osiami jest duży (np. naczepa)
        const lastAx = group[group.length - 1];
        if (lastAx.gapAfter > 180) {
          merged.push({
            isGap: true,
            colspan: 1,
            gapAfter: lastAx.gapAfter,
          });
        }

        i += groupLength;
      }

      return merged;
    },
  },
  // Po utworzeniu komponentu: reaguj na zmianę id pojazdu w trasie i pobieraj nowe dane
  created() {
    this.$watch(
      () => this.$route.params.id,
      () => {
        this.fetchData();
      },
      { immediate: true }
    );
  },
  methods: {
    // Obsługa kliknięcia przycisku VMS - pokazuje dropdown lub czyści treść na znaku
    handleVmsButton() {
      if (this.buttonText.startsWith('Anuluj wyświetlanie treści')) {
        // jeśli aktualnie jest wyświetlana treść - anuluj
        this.clearVms();
      } else if (this.canManageVms) {
        // w przeciwnym razie rozwiń/zwiń dropdown
        this.isOpen = !this.isOpen;
      }
    },
    // Wyślij polecenie do znaku VMS, aby wyświetlił komunikat dla wszystkich ciężarówek
    displayAllTrucks() {
      CurrentMeasurementsService.displayPlateOrAllTrucks(this.vehicle.id, true).then(() => {
        this.isOpen = false;
      });
    },
    // Wyślij polecenie do znaku VMS, aby wyświetlił numer rejestracyjny pojazdu
    displayPlateNumber() {
      CurrentMeasurementsService.displayPlateOrAllTrucks(this.vehicle.id, false).then(() => {
        this.isOpen = false;
      });
    },
    // Wyślij polecenie do znaku VMS, aby usunął treść z tablicy
    clearVms() {
      CurrentMeasurementsService.clearPlateVms(this.vehicle.id).then(() => {
        this.canManageVms = false;
        this.isOpen = false;
      });
    },
    // Zamknij dropdown po kliknięciu poza nim
    onClickOutside(e) {
      const dropdown = this.$refs.dropdown;

      if (dropdown && !dropdown.contains(e.target)) {
        this.isOpen = false;
      }
    },
    // Buduje obiekt osi do tabeli (pojedyncza oś)
    _buildSingleAxle(ax) {
      return {
        colspan: 1,
        overload: ax.overload,
        dataAxMinus: ax.dataAxMinus,
        dataAxCenter: ax.dataAxCenter,
        dataAxPlus: ax.dataAxPlus,
        dataLeft: ax.dataLeft,
        dataRight: ax.dataRight,
      };
    },
    // Pobiera dane pojazdu z backendu
    fetchData() {
      this.error = this.post = null;
      this.vehService
        .get(
          this.$route.params.id,
          this.$route.params.location,
          this.$route.params.createdAt
        )
        .then((data) => {
          // const payload = data && data.vehicle
          //   ? data
          //   : { vehicle: data, euroNorms: null, euroMeta: null };
          //
          // const { vehicle, euroNorms } = payload;
          //
          // this.setVehicleData(vehicle);
          // this.euroNorms = euroNorms;   // <- zapamiętaj normy EURO do wyświetlenia
          // // this.euroMeta  = euroMeta;
          //
          // // Sprawdź czy znak VMS dostępny dla tego pojazdu
          // if (data.vehicle.plateVmsReadablePointAt) {
          //   this.isVmsAvailable(data.vehicle.id);
          // }
          const vehicleObj = data?.vehicle ?? data;
          const euroNorms  = data?.euroNorms ?? null;

          this.setVehicleData(vehicleObj);
          this.euroNorms = euroNorms;

          // Sprawdź VMS na ujednoliconym obiekcie
          if (vehicleObj?.plateVmsReadablePointAt) {
            this.isVmsAvailable(vehicleObj.id);
          }
        });
    },
    // Ustawia dane pojazdu w stanie komponentu
    setVehicleData: function (data) {
      if (data) {
        this.vehicle = data;
        this.vehicle.checkpointTime = new Date(this.vehicle.checkpointTime);
        this.vehicle.timeToRemove = new Date(this.vehicle.checkpointTime.getTime() - this.momentDiffServer);
        this.chartData = this.getChartData(this.vehicle);
        this.axlesData = this.getAxlesData(this.vehicle.axles);
      }
    },
    // Sprawdź dostępność i status VMS dla pojazdu (pojedynczy polling + automatyczny polling co sekundę)
    isVmsAvailable(id) {
      this.vehService.getPlateVmsStatus(id).then((data) => {
        this.displayPlateVmsStatus(id, data);
      })
      .catch(() => {
        this.canManageVms = false;
        this.isOpen = false;
      })
      .finally(() => {
        this.startGetPlateVmsStatus(id);
      });
    },
    // Aktualizuje tekst i stan przycisku na podstawie statusu VMS
    displayPlateVmsStatus(id, plateVmsStatus) {
      const plateVms = plateVmsStatus.plateVms;

      if (plateVmsStatus.manageable) {
        if (plateVms.contentDisplayed) {
          this.buttonText = 'Anuluj wyświetlanie treści: ';
          if (plateVms.allTrucksDisplayed) {
            this.buttonText += 'Pojazdy ciężarowe';
          } else {
            this.buttonText += this.vehicle.plateLpr;
          }
        } else {
          const timeToVms = this.createCheckpointTime(this.vehicle.plateVmsReadablePointAt);
          this.buttonText = 'Wyświetl wybraną treść na znaku - ' + timeToVms;
        }
        this.canManageVms = true;
      } else {
        // Obsługa różnych przypadków braku dostępności znaku/scenariusza
        if (!plateVms.available) {
          this.buttonText = 'Znak niedostępny';
        } else if (!plateVms.scenarioEnabled) {
          this.buttonText = 'Scenariusz dla znaku nie jest włączony';
        } else if (!plateVms.contentDisplayed) {
          this.buttonText = 'Pojazd minął już znak';
        } else if (plateVms.vehicle.id == id) {
          this.buttonText = 'Wytypowano już ten pojazd do kontroli';
        } else {
          this.buttonText = 'Wytypowano już inny pojazd do kontroli';
        }
        this.canManageVms = false;
      }
    },
    // Oblicz różnicę czasu do wyświetlenia treści na znaku VMS
    createCheckpointTime(plateVmsReadablePointAt) {
      const serverTime = new Date(Date.now() + this.momentDiffServer);
      const plateMs    = Date.parse(plateVmsReadablePointAt);
      const serverMs   = serverTime.getTime();

      const timeDiffMs = Math.round((plateMs - serverMs) / 1000) * 1000;
      const diffDate   = new Date(Math.abs(timeDiffMs));

      const hh = diffDate.getUTCHours().toString().padStart(2, '0');
      const mm = diffDate.getUTCMinutes().toString().padStart(2, '0');
      const ss = diffDate.getUTCSeconds().toString().padStart(2, '0');

      const timeString = [
        ...(hh !== '00' ? [hh] : []),
        mm,
        ss
      ].join(':');

      return timeDiffMs >= 0 ? timeString : '-' + timeString;
    },
    // Polling statusu VMS co sekundę (dopóki można zarządzać tablicą)
    startGetPlateVmsStatus(id) {
      let nowInMiliseconds = (new Date()).getTime() + 3000;
      const checkpointAdditionalTime = this.momentDiffServer * 1000;
      nowInMiliseconds -= checkpointAdditionalTime;

      if ((this.vehicle.timeToRemove.getTime() - nowInMiliseconds) >= 0) {
        setTimeout(() => {
          this.isVmsAvailable(id);
        }, 1000);
      }
    },
    // Formatuje boolean jako TAK/NIE (dla prezentacji w tabeli)
    evaluateBoolean(bool) {
      if (bool) {
        return "TAK";
      }
      return "NIE";
    },
    // Formatuje liczby całkowite do prezentacji
    evaluateInt(value) {
      if (value) {
        return value;
      }
      return 0;
    },
    // Formatuje liczby zmiennoprzecinkowe do prezentacji
    evaluateDecimal(value) {
      if (value) {
        return value;
      }
      return "0,00";
    },
    // Pobiera kod ISO-2 kraju na podstawie ISO-3 (do flag)
    getCode(value) {
      return getCountryISO2(value);
    },
    // Tworzy dane do wykresu na podstawie próbek kształtu pojazdu (shapeSamples)
    getChartData(vehicleData) {
      if (!vehicleData) {
        return {
          labels: [" "],
          datasets: [{ data: [] }],
        };
      }
      let dataset = [];
      let labelsData = [];
      if (vehicleData.shapeSamples) {
        for (const dataInt in vehicleData.shapeSamples) {
          dataset.push(vehicleData.shapeSamples[dataInt]);
          labelsData.push("");
        }
      }

      return {
        labels: labelsData,
        datasets: [{ data: dataset }],
      };
    },
    // Tworzy dane o osiach pojazdu (do tabeli z masami i naciskami)
    getAxlesData(axles) {
      let ax = [];
      for (const item in axles) {
        const exData = axles[item];
        if (item > 0) {
          ax[ax.length - 1].gapAfter = exData.gap;
        }
        ax.push({
          dataAxMinus: exData.minTotalLoad,
          dataAxCenter: exData.totalLoad,
          dataAxPlus: exData.maxTotalLoad,
          dataLeft: exData.leftWeight,
          dataRight: exData.rightWeight,
          gapAfter: 0,
          overload: exData.overload,
        });
      }
      return ax;
    },
    // Czy użytkownik ma historię powrotu (do przycisku "back")
    hasHistory() {
      return window.history.length > 1;
    },
    // Zwraca klasę CSS dla przeciążonej masy całkowitej
    getWeightClassName(vehicle) {
      if (vehicle.totalLoad >= vehicle.limitTotalLoad) {
        return "measurement-row-field-b-red";
      }
      return "measurement-row-field-b";
    },
    // Zwraca klasę CSS dla przekroczenia prędkości
    getSpeedClassName(vehicle) {
      if (vehicle.overspeed) {
        return "measurement-row-field-b-red";
      }
      return "measurement-row-field-b";
    },
    // Callback po zmianie miniatury zdjęcia
    wasSetCallback() {
      this.selectedSmallImage = 0;
    },
    // Pobiera raport PDF (ZIP) z backendu
    retrieveZip() {
      this.isDownloading = true;
      this.vehService
        .getVehicleZip(this.vehicleData.id, "pdf-with-image")
        .then((data) => {
          this.vehService
            .fetch(data.link)
            .then((response) => {
              const link = document.createElement("a");
              link.href = URL.createObjectURL(response);

              // Generuje nazwę pliku na podstawie daty
              const now = new Date();
              const year = now.getFullYear();
              const month = String(now.getMonth() + 1).padStart(2, '0');
              const day = String(now.getDate()).padStart(2, '0');
              const hours = String(now.getHours()).padStart(2, '0');
              const minutes = String(now.getMinutes()).padStart(2, '0');
              const seconds = String(now.getSeconds()).padStart(2, '0');
              const fileName = `vehicle_report_${day}_${month}_${year}_${hours}_${minutes}_${seconds}`;
              link.download = fileName;

              link.click();
              this.isDownloading = false;
              URL.revokeObjectURL(link.href);
            })
            .catch(console.error);
        })
        .catch((error) => {
          this.loading = false;
          console.error(error);
        });
    },
    // Powrót do listy (lub widoku archiwalnego) i ewentualne wymuszenie przeładowania
    back() {
      // if (this.$route.path.startsWith("/vehicleArch")) {
      //   // ARCHIWUM → zawsze lista wyników
      //   const archival = useArchivalFiltersStore();
      //       archival.setStep(4);
      //       archival.setIsResult(true);
      //       archival.setShouldReload(true);
      //       this.$router.push({ path: "/archival" });
      //       return;
      // }
      if (this.$route.path.startsWith("/vehicleArch")) {
        const page = this.$route.query.page;
        const archival = useArchivalFiltersStore();

        archival.$patch({ savedVehicles: [] });
        archival.setStep(4);
        archival.setIsResult(true);
        // archival.setShouldReload(true);

        this.$router.push({
          path: "/archival",
          query: page ? { page: String(page) } : {},
        });
        return;
      }

      // BIEŻĄCE → zawsze lista (krok 3)
      const current = useCurrentStore();
      current.setStepValue(3);
      this.$router.push({ path: "/" });
    },
    // Przełączanie zdjęcia pojazdu (po kliknięciu)
    nextImage() {
      const totalImages = this.vehicleData.images.length;
      this.currentImageIndex = (this.currentImageIndex + 1) % totalImages;
    },
    // Ustawienie aktualnego zdjęcia po indeksie
    setImage(number) {
      this.currentImageIndex = number - 1;
    },
  },
};
</script>

<style scoped src="../assets/css/viver-style.css"></style>
<style scoped>

.actions {
  background-color: white;
}

.actions-down {
  background-color: white;
  min-height: 43px;
}

.download {
  margin: 8px;
  padding: 0;
}

.actions button, .actions-down button {
  border: 0;
  font-size: 19px;
  font-weight: bold;
  background: none;
}

.actions .pdf {
  margin-top: 5px;
}

.actions .btn-next, .actions-down .btn-next {
  margin-right: 50px;
  padding: 0 40px 8px 8px;
  position: relative;
  color: #58585a;
}

.actions .btn-next:before, .actions-down .btn-next:before {
  content: "";
  position: absolute;
  right: 0;
  width: 30px;
  height: 20px;
  background: url("../assets/icons/dalej.png") no-repeat left top;
}

.actions .btn-next:hover, .actions-down .btn-next:hover {
  color: black;
}

.actions .btn-next:hover:before, .actions-down .btn-next:hover:before {
  background: url("../assets/icons/dalej_over.png") no-repeat left top;
}

.actions .btn-prev, .actions-down .btn-prev {
  margin-left: 30px;
  padding: 0 0 0 40px;
  position: relative;
  color: #58585a;
}

.actions .btn-prev:before, .actions-down .btn-prev:before {
  content: "";
  position: absolute;
  left: 0;
  top: 17px;
  width: 30px;
  height: 20px;
  background: url("../assets/icons/powrot.png") no-repeat left top;
}

.no-timer:before {
  top: 9px !important;
}

.actions .btn-prev:hover, .actions-down .btn-prev:hover {
  color: black;
}

.actions .btn-prev:hover:before, .actions-down .btn-prev:hover:before {
  background: url("../assets/icons/powrot_over.png") no-repeat left top;
}

button {
  border: 0;
  font-size: 19px;
  font-weight: bold;
  background: none;
}

.btn-prev {
  margin-left: 30px;
  padding: 6px 0 0 40px;
  position: relative;
  color: #58585a;
}

.btn-prev span {
  padding-top: 0;
}

.btn-prev:before {
  content: "";
  position: absolute;
  left: 30px;
  top: 22px;
  width: 30px;
  height: 20px;
  background: url("../assets/icons/powrot.png") no-repeat left top;
}

.btn-prev:hover {
  color: black;
}

.btn-prev:hover:before {
  background: url("../assets/icons/powrot_over.png") no-repeat left top;
}

.details-row-field {
  font-size: 14px;
}

.details-row-field-b {
  font-weight: bold;
  font-size: 14px;
}

.vehicle-data {
  margin: 15px 0;
}

.vehicle-data > div {
  padding: 10px 50px;
  border-right: 1px solid #b8b8b6;
}

.vehicle-data > div.border-right-0 {
  border-right: 0;
}

.vehicle-data > div .row {
  padding: 5px;
  border-bottom: 1px solid #b8b8b6;
}

.vehicle-data > div .row .col-9 {
  text-align: left;
}

.vehicle-data > div .row .col-3 {
  text-align: center;
}

.side-info {
  width: 365px;
  background: url("../assets/l-filter-bg.png") repeat-y right;
}

.details {
  width: 100%;
}

.side-info .date-time,
.side-info .info {
  margin: 15px 0;
  font-size: 14px;
  padding-left: 20px;
  border-bottom: 1px solid #b8b8b6;
}

.side-info .info {
  padding: 5px 0 18px 15px;
}

.side-info .location {
  margin: 15px 0 0;
  font-size: 14px;
  padding-left: 20px;
}

.date-time > div,
.location > div {
  font-size: 24px;
  margin: 8px 0;
}

.date-time .time {
  padding-left: 10px;
}

.date-time .date {
  padding-right: 10px;
  border-right: 1px solid #b8b8b6;
}

/* .info .label {
  width: 160px;
  border-right: 1px solid #b8b8b6;
}

.info .value {
  padding-left: 15px;
  font-size: 18px;
} */

/* wiersz z etykietą i wartością */
.info.d-flex {
  align-items: flex-start;       /* opcjonalnie: top-align przy 2+ liniach */
}

/* stała szerokość etykiety */
.info .label {
  border-right: 1px solid #b8b8b6;
  flex: 0 0 160px;               /* równo 160px, bez kurczenia */
}

/* wartość: niech się łamie i zajmuje resztę */
.info .value {
  flex: 1 1 auto;
  min-width: 0;                  /* KLUCZOWE przy flex, inaczej tekst nie łamie */
  white-space: normal;           /* na wszelki wypadek */
  overflow-wrap: anywhere;       /* łamie też długie ciągi bez spacji */
  word-break: break-word;        /* fallback dla starszych przeglądarek */
  padding-left: 10px;
}


h3 {
  margin-bottom: 0;
  font-weight: bold;
  padding: 10px 20px;
  background-color: white;
}

.vehicle-params h3 {
  position: relative;
}

.vehicle-params h3 button {
  position: absolute;
  right: 30px;
  top: 10px;
  padding: 5px 15px 5px 25px;
}

.vehicle-params h3 button::before {
  position: absolute;
  left: 5px;
  top: 5px;
  content: "";
  width: 30px;
  height: 20px;
  background: url("../assets/icons/pobierz.png") no-repeat left top;
}

.axis-info-data {
  font-size: 12px;
  padding: 25px;
  border-bottom: 1px solid #b8b8b6;
}

.axis-info-data-table {
  font-size: 12px;
  margin: 25px;
  border-bottom: 1px solid #b8b8b6;
  width: 100%;
}

.axis-info-data-table th:first-child {
  width: 135px;
}


.axis-info-data-table th:nth-child(2) {
  width: 50px;
  padding-right: 170px;
}

.axis-info-data-table th:nth-child(3) {
  width: 5px;
}

.axis-info-data-mass {
  width: 50%;
  justify-content: center;
  margin: 1rem;
}

.axis-wheels {
  font-size: 18px;
  padding: 25px;
}

.row {
  margin: 0;
  justify-content: center;
}

.row > * {
  padding: 0;
}

.plate-flag {
  background: #204499;
  color: #f5f4f2;
  font-weight: bold;
  font-size: 15px;
  width: 60px;
}

.plate {
  color: black;
  font-weight: bold;
  font-size: 31px;
  padding-left: 5px;
}

.plate-item {
  height: 47px;
  background: white;
  border-bottom: 1px solid #b8b8b6;
}

.vl {
  border-left: 1px solid black;
  height: 25px;
  top: 0;
}

.no-margin-top {
  margin-top: 0px;
}

.wheel-diff-val {
  width: 100%;
}

.wheel-diff-gap {
  font-weight: bold;
}

.measurement-row-field-b {
  font-weight: bold;
  font-size: 14px;
}

.measurement-row-field-b-red {
  font-weight: bold;
  font-size: 14px;
  color: red;
}

.violation {
  background-color: #fa4b4a;
  color: black !important; 
}

.axis-table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
  table-layout: fixed;
  background: #eaeaea;
}

.axis-table th,
.axis-table td {
  padding: 8px 4px;
  vertical-align: middle;
  font-size: 13px;
}

.axis-table th:first-child {
  font-weight: bold;
  color: #333;
  white-space: nowrap;
}

.row-center th {
  font-weight: bold;
}

.wheel-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
}

.wheel-icon img {
  height: 100px;
}

.wheel-icon span {
  font-weight: bold;
  color: red;
}

.wheel-icon.overloaded span {
  color: red;
}

.row-bottom {
  border-bottom: 1px solid #b8b8b6;
}

.overload {
  color: #fa4b4a;
}

#axisNameRow {
  font-weight: bold;
}

.row-top th, .row-bottom th {
  font-weight: normal !important;
}

.actions .btn {
  margin: 10px 15px 10px 0;
  background-color: #e0e0e0;
  cursor: pointer;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 100px;
  font-weight: normal;
  padding: 0;
  border: 0;
  font-size: 12px;
}

.actions .timer {
  color: #58585a;
}

.middle-axis-value {
  font-size: 13px;
}

#axisTopRow, #axisBottomRow {
  font-size: 13px;
}

.buttons {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
}

.dropdown-wrapper {
  position: relative;
  display: inline-block;
  overflow: visible;
  z-index: 1000;
}

.dropdown-wrapper > button.btn {
  display: block;
  padding: 10px 0 10px 0;
}

.dropdown-list {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-55%);
  margin: 0.25rem 0;
  padding: 0;
  list-style: none;
  background: #fff;
  border: 1px solid #ccc;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
  white-space: nowrap;
  z-index: 2000;
}

.dropdown-list li {
  padding: 8px 12px;
  cursor: pointer;
  white-space: nowrap;
}
.dropdown-list li:hover {
  background: #f5f5f5;
}

.info .fw-bold {
  font-size: 13px;
}
</style>